import React from "react";
import "./TermsModal.css";

const TermsModal = ({ terms, onClose }) => {
  return (
    <div className="terms-modal-overlay" onClick={onClose}>
      <div className="terms-modal" onClick={(e) => e.stopPropagation()}>
        <h3>📜 Booking Terms</h3>
        <ul>
          {terms.map((term, i) => (
            <li key={i}>{term}</li>
          ))}
        </ul>
        <button className="close-btn" onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default TermsModal;